import type {
  ClientUserListResponse,
  ClientUserResponse,
} from '@contracts/clientUsers/ClientUserResponse';
import type { ClientUser } from '@src/clientUser/manage/ClientUser';
import { AuthenticatedClient } from '@src/common/services/AuthenticatedClient';

export const ClientUsersClient = {
  findAllForClient: async ({
    clientId,
  }: {
    clientId: string;
  }): Promise<ClientUser[]> => {
    const {
      data: { clientUsers },
    } = await AuthenticatedClient.get<ClientUserListResponse>(
      `/clientUsers/${clientId}`,
    );

    return clientUsers.map((clientUserResponse: ClientUserResponse) => ({
      id: clientUserResponse.id,
      name: clientUserResponse.name,
      email: clientUserResponse.email,
      phone: clientUserResponse.phone,
      isInactive: clientUserResponse.isInactive,
      cognitoStatus: clientUserResponse.cognitoStatus,
    }));
  },
  create: async (request: {
    clientId: string;
    name: string;
    email: string;
    phone: string;
  }) => {
    await AuthenticatedClient.post(`/clientUsers`, request);
  },
  edit: async (
    clientUserId: string,
    request: {
      clientId: string;
      name: string;
      phone: string;
    },
  ) => {
    await AuthenticatedClient.put(`/clientUsers/${clientUserId}`, request);
  },
  deactivate: async (clientUserId: string, clientId: string) => {
    await AuthenticatedClient.patch(
      `/clientUsers/${clientUserId}/${clientId}:deactivate`,
    );
  },
  reactivate: async (clientUserId: string, clientId: string) => {
    await AuthenticatedClient.patch(
      `/clientUsers/${clientUserId}/${clientId}:reactivate`,
    );
  },
  confirmCognitoUser: async (clientUserId: string, clientId: string) => {
    await AuthenticatedClient.patch(
      `/clientUsers/${clientUserId}/${clientId}:confirm-cognito`,
    );
  },
};
